import { render } from "./VerVentas.vue?vue&type=template&id=3426cf49&scoped=true"
import script from "./VerVentas.vue?vue&type=script&lang=js"
export * from "./VerVentas.vue?vue&type=script&lang=js"

import "./VerVentas.vue?vue&type=style&index=0&id=3426cf49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3426cf49"]])

export default __exports__